var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max"},[_c('div',{staticClass:"left_box"},[_c('RegisterAndLoginBackImage',{attrs:{"imgPath":require('../../../assets/newImage/bg_2.jpg')}})],1),_vm._v(" "),_c('div',{staticClass:"right_box"},[_c('router-view'),_vm._v(" "),_c('footerInfo',{staticStyle:{"position":"absolute","bottom":"0","left":"0","right":"0"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfc50782","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newPages/login/register.vue
// module id = null
// module chunks = 